export default __webpack_public_path__ + "static/media/balance.21f25d9b.svg";